export default __webpack_public_path__ + "static/media/leavestatus.2e5303d0.png";